



























/** @format */

import { Vue, Component, Prop, Watch, Emit, Mixins } from 'vue-property-decorator';
// import { basePark } from '@/common/api/smart-parking/parking-lot-management/types'
import { IAntPaginationConfig } from '@/types/table';

// 导入字典
// import { dictServiceTypeMap, makeInvoiceTypeMap } from '@/types/smart-parking/setting-management/dictionaries'
import { makeInvoiceTypeMap } from '@/types/system-management/dictionaries';
import TableWidthMixin from '@/common/mixins/table-width';
import TableMixin from '@/common/mixins/table';
@Component({
  components: {}
})
export default class InvoiceSettingTable extends Mixins(TableWidthMixin, TableMixin) {
  // 查询参数
  private filterParams: any = {};
  // 列表数据
  private listData: any[] = [];

  // 开票项目
  private typeList: any = makeInvoiceTypeMap;

  // 列表传入的数据
  @Prop({
    type: Array,
    default() {
      return [];
    }
  })
  data!: any[];

  // 列表传入搜索参数
  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  searchParams!: any;

  // 列表传入列表总数
  @Prop({
    type: Number,
    default: 0
  })
  totalCount!: number;

  // 是否Loading中
  @Prop({
    type: Boolean,
    default: false
  })
  listLoading!: boolean;

  // 初始化列表数据
  @Watch('data', {
    deep: true,
    immediate: true
  })
  onChangeData(newVal: any[], oldVal: any[]) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.listData)) {
      this.listData = JSON.parse(JSON.stringify(newVal));
    }
  }

  // 初始化查询参数
  @Watch('totalCount', {
    immediate: true
  })
  onChangeTotalCount(newVal: number, oldVal: number) {
    this.total = newVal; // 初始化分页总条数
  }

  // 初始化总条数
  @Watch('searchParams', {
    deep: true,
    immediate: true
  })
  onChangeSearchParams(newVal: any, oldVal: any) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.filterParams)) {
      this.filterParams = JSON.parse(JSON.stringify(newVal));
      this.current = Number(this.filterParams.currPage); // 初始化分页当前页码
      this.pageSize = Number(this.filterParams.pageSize); // 初始化分页每页条数
    }
  }

  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '企业名称',
        width: 200,
        dataIndex: 'companyName',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '纳税人识别号',
        dataIndex: 'saleCode',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '所属机构',
        dataIndex: 'organName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        width: 140,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  // 分页改变
  @Emit('on-init')
  handleTableChange(pagination: IAntPaginationConfig, filters: any, sorter: any) {
    const { current, pageSize } = pagination;
    this.filterParams.currPage = current;
    this.filterParams.pageSize = pageSize;
    this.current = Number(this.filterParams.currPage); // 初始化分页当前页码
    this.pageSize = Number(this.filterParams.pageSize); // 初始化分页每页条数
    return this.filterParams;
  }

  // 新增
  @Emit('on-add')
  handleAdd(data: any) {
    return data;
  }

  // 修改
  @Emit('on-update')
  handleUpdate(data: any) {
    return data;
  }

  // 删除
  @Emit('on-delete')
  handleDelete(data: any) {
    return data;
  }
}
